/**
 * Parse the OptanonConsent cookie's `groups=` segment and return the list of
 * categories the user has consented to (entries marked `:1`).
 *
 * The cookie body looks like
 *   `isGpcEnabled=0&datestamp=...&groups=C0001%3A1%2CC0002%3A0%2CC0003%3A1`
 * which decodes to `C0001:1,C0002:0,C0003:1`. Returns only the categories
 * with `:1`. Empty/malformed inputs return an empty array.
 *
 * Shared between the server-side helper (`serverConsent.ts`, which parses the
 * raw cookie header on the request) and the client-side helper
 * (`clientConsent.ts`, which parses `document.cookie`).
 */
export function parseOptanonConsentGroups(cookieValue: string | undefined): string[] {
  if (!cookieValue) return [];
  const parts = cookieValue.split('&');
  for (const part of parts) {
    if (!part.startsWith('groups=')) continue;
    try {
      const decoded = decodeURIComponent(part.slice('groups='.length));
      return decoded
        .split(',')
        .map(entry => {
          const [category, consent] = entry.split(':');
          return consent?.trim() === '1' ? category.trim() : '';
        })
        .filter(Boolean);
    } catch {
      return [];
    }
  }
  return [];
}
